import CustomTargetLinkExample from "./examples/CustomTargetLink.Example";
import LinkExample from "./examples/Link.Example";
import SubtleLinkExample from "./examples/SubtleLink.Example";

export default [
    {
        title: "Basic link",
        component: LinkExample,
        code: require("!raw-loader!./examples/Link.Example.tsx"),
        normalBackground: true
    },
    {
        title: "Custom target",
        component: CustomTargetLinkExample,
        code: require("!raw-loader!./examples/CustomTargetLink.Example.tsx"),
        normalBackground: true
    },
    {
        title: "Subtle link",
        component: SubtleLinkExample,
        code: require("!raw-loader!./examples/SubtleLink.Example.tsx")
    }
];
